


















import { computed, defineComponent, ref } from '@vue/composition-api';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import soilApiService from '@/services/soilApiService';
import { Group } from '@/store/types';

export default defineComponent({
	components: { ConfirmDialog },
	inheritAttrs: false,
	props: {
		group: {
			type: Object as () => Group,
			required: true,
		},
	},
	setup(props, { root }) {
		const showConfirmationDialog = ref<boolean>(false);
		const deleteError = ref();
		const isLoading = ref(false);

		const errorMessage = computed<string>(() =>
			deleteError.value
				? deleteError.value?.response?.data?.message ||
				  'An error occurred while attempting to delete the group. Please try again.'
				: ''
		);

		const handleConfirmDelete = async () => {
			try {
				isLoading.value = true;
				await soilApiService.deleteGroup({ groupId: props.group.id });
				showConfirmationDialog.value = false;
			} catch (err) {
				deleteError.value = err;
			} finally {
				isLoading.value = false;
			}
		};

		const handleCleanup = () => {
			deleteError.value = null;
			isLoading.value = false;
			root.$store.dispatch('groups/getGroups');
		};

		return {
			showConfirmationDialog,
			handleConfirmDelete,
			isLoading,
			errorMessage,
			handleCleanup,
		};
	},
});
